import { handleMessages, load } from './util';

$(document).on('change', '[data-dimensions-form] select, [data-dimensions-form] input', function() {
  const $form = $(this.form);
  const query = $form.serializeArray();
  const url = `${$form.attr('action') || ''}?${$.param(query)}`;
  $.stores.item.fetch(url, true);
});

// Only one thumb active at a time
$(document).on('click', '[data-thumb]', function() {
  $(this).addClass('active').siblings('[data-thumb]').removeClass('active');
});

// Persist custom artnum on change
$(document).on('submit', '[data-item-custom-artnum]', event => event.preventDefault());
$(document).on('change', '[data-item-custom-artnum]', function(event) {
  event.preventDefault();

  const $form = $(this).closest('form');
  const promise = $.ajax({
    url: $form.attr('action'),
    method: 'POST',
    data: $form.serialize(),
  }).then(handleMessages).then((data) => {
    if (!data.status) {
      throw new Error('Could not save customer item id.');
    }
    return data;
  });

  load($form, promise, {
    errorClass: 'error',
  });
});

$(document).on('click', '[data-item-image-zoom]', (event) => {
  event.preventDefault();
  $('[data-item-zoom-reveal]').foundation('open');
  setTimeout(() => {
    $('[data-item-zoom-reveal]').get(0).focus();
  }, 0);
});

$(document).ready(() => {
  let primaryImageURL = null;
  let moodImageURL = null;
  let currentTarget = null;
  const itemImages = $('.shopitem__image');

  itemImages.on('mouseenter', (event) => {
    currentTarget = $(event.target);
    moodImageURL = currentTarget.data('mood-image-url');
    if (moodImageURL && moodImageURL.length) {
      primaryImageURL = $(event.target).css('background-image');
      currentTarget.css('background-image', moodImageURL);
    }
  });

  itemImages.on('mouseleave', () => {
    if (moodImageURL && moodImageURL.length) {
      currentTarget.css('background-image', primaryImageURL);
    }
  });
});

$(document).on('keyup', '[data-item-zoom-reveal]', (event) => {
  if (event.keyCode === 37) {
    $('[data-item-zoom-reveal]').find('[data-carousel]').data('owl.carousel').prev();
  } else if (event.keyCode === 39) {
    $('[data-item-zoom-reveal]').find('[data-carousel]').data('owl.carousel').next();
  }
});

$(document).on('submit', '[data-item-report-form]', function(event) {
  event.preventDefault();
  const $form = $(this).closest('form');

  const promise = $.ajax({
    url: $form.attr('action'),
    method: 'POST',
    data: $form.serializeArray(),
  }).then(handleMessages).then((data) => {
    setTimeout(() => $form.foundation('close'), 1500);
    return data;
  });

  load($form, promise, {
    errorClass: 'error',
  });
});

$(document).on('closeme.zf.reveal', '[data-item-report-form]', function() {
  this.reset();
  $(this).removeClass('error');
  $(this).find('[data-cart-report-form]').html('').hide()
    .removeClass('alert');
});

$(document).on('input', '[data-item-configuration-form] [data-item-configuration-evaluate]', function() {
  const $config = $(this).closest('[data-item-configuration]');
  $config.find('[data-add-cart]').addClass('add-to-cart--disabled');
});

$(document).on('change', '[data-item-configuration-form] [data-item-configuration-evaluate]', function() {
  const $form = $(this).closest('[data-item-configuration-form]');
  $form.submit();
});

$(document).on('submit', '[data-item-configuration-form]', function(event) {
  event.preventDefault();
  if (!this.disabled) {
    const $this = $(this);
    const $item = $('[data-item-detail]');
    const url = $this.attr('action');
    $.each(this.elements, (_, elem) => {
      elem.readOnly = true;
    });
    $.stores.item.config(url, $item, $this.serialize());
    this.disabled = true;
  }
});

$(document).on('change', '[data-item-configuration-form] input[name="step"]', function() {
  document.querySelectorAll('.item__configuration__tabs-nav-item').forEach((el) => {
    $(el).removeClass('is-active');
  });
  const tab = document.querySelector(`label[for=${this.id}]`);
  $(tab).addClass('is-active');
});

$(document).on('click', '[data-watchlist]', function() {
  const $this = $(this);
  if (!$this.attr('data-add-watchlist')) {
    return;
  }
  const itemId = $this.attr('data-watchlist');
  const active = $this.hasClass('active');
  $(`[data-watchlist="${itemId}"]`)[active ? 'removeClass' : 'addClass']('active');
  $.ajax({
    url: $this.attr(active ? 'data-remove-watchlist' : 'data-add-watchlist'),
    method: 'post',
  }).then((json) => {
    $('[data-watchlist-count]').text(json.count)[json.count ? 'removeClass' : 'addClass']('hide');
    $('[data-watchlist-preview]')[json.count ? 'removeClass' : 'addClass']('hide');
    $('[data-watchlist-preview-content]').html('');
    if ($('[data-clear-watchlist]').length) {
      document.location.reload();
    }
    if (json.tracking_event_data) {
      if (window.gtag && json.tracking_event_data.analytics) {
        if (json.tracking_event_data.analytics.event && json.tracking_event_data.analytics.data) {
          window.gtag(
            'event',
            json.tracking_event_data.analytics.event,
            json.tracking_event_data.analytics.data,
          );
        }
      }
    }
  });
});

$(document).on('click', '[data-watchlist-preview] [data-remove-watchlist]', function(event) {
  event.stopPropagation();
  event.preventDefault();
  const $this = $(this);
  const $preview = $this.closest('[data-watchlist-preview]');
  const itemId = $this.attr('data-watchlist');
  $(`[data-watchlist="${itemId}"]`).removeClass('active');
  load(
    $preview.find('[data-watchlist-preview-widget]'),
    $.ajax({
      url: $this.attr('data-remove-watchlist'),
      method: 'post',
    }).then((json) => {
      $('[data-watchlist-count]').text(json.count)[json.count ? 'removeClass' : 'addClass']('hide');
      $('[data-watchlist-preview]')[json.count ? 'removeClass' : 'addClass']('hide');
      if ($('[data-clear-watchlist]').length) {
        document.location.reload();
        return true;
      }
      return $.ajax({
        url: $preview.attr('data-watchlist-preview'),
        method: 'GET',
      }).then((html) => {
        $('[data-watchlist-preview-content]').html(html);
      });
    }),
  );
});

$(document).on('show.zf.dropdown', '[data-watchlist-preview]', function() {
  if (!$('[data-watchlist-preview-content]').html().trim()) {
    load(
      $(this).find('[data-watchlist-preview-widget]'),
      $.ajax({
        url: $(this).attr('data-watchlist-preview'),
        method: 'GET',
      }).then((html) => {
        $('[data-watchlist-preview-content]').html(html);
      }),
    );
  }
});

$(document).on('click', '[data-subscribe-item-stock]', function() {
  $.ajax({
    method: 'GET',
    url: $(this).attr('data-subscribe-item-stock'),
  }).done((response) => {
    $(response).appendTo($('body')).foundation().foundation('open');
  });
});

$(document).on('submit', '[data-subscribe-item-stock-reveal]', function(event) {
  event.preventDefault();
  const $form = $(this);
  load(
    $form,
    $.ajax({
      url: $form.attr('action'),
      data: $form.serialize(),
      method: 'post',
    }),
  ).done((response) => {
    if (!response) {
      setTimeout(() => $form.foundation('close'), 1500);
    } else {
      $form.foundation('close');
      $(response).appendTo($('body')).foundation().foundation('open');
    }
  });
});
